<template>
  <h1 class="text-center">Calendars</h1>
</template>

<script>
export default {
  name: "Calendars"
}
</script>

<style scoped>

</style>